import { useMutation } from '@tanstack/react-query';
import { Employee } from '../../../types/Employee';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { mutationKeys } from '../mutationKeys';

export const updateEmployee = async (uuid: string | null, formData: Employee | null) => {
  if (uuid === null || formData === null) return null;

  const response = await CustomAxios.put(`employees/${uuid}`, formData);
  const { data } = response;
  return data;
};
interface UseUpdateEmployeeFormProps {
  uuid: string;
  onSuccessCallback: () => void;
}
export function useUpdateEmployee({ uuid, onSuccessCallback }: UseUpdateEmployeeFormProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateEmployee],
    mutationFn: (formData: Employee | null) => updateEmployee(uuid, formData),
    onSuccess: (data: Employee) => {
      // fetch the employee again after create
      // invalidate both the special UUIDs (current, new) and the true, returned UUID
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEmployees, uuid] });
      if (data?.uuid) queryClient.invalidateQueries({ queryKey: [queryKeys.allEmployees, data.uuid] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const employee: Employee = err.response.data as Employee;
        queryClient.setQueryData([queryKeys.allEmployees, employee.uuid], employee);
      }
    },
  });
}
